var Ep2019ListConfig = {
   "europa-italia-in-comune-pde-italia":{
      "label": "+Europa - Italia In Comune - Pde Italia",
      "short_label": "+Europa",
      "color": "#EF5E60",
      "political_pos": 1,
      "type": "lista",
      "logo": ""
   },
   "casapound-italia-destre-unite":{
      "label": "Casapound Italia - Destre Unite",
      "short_label": "Casapound",
      "color": "#525252",
      "political_pos": 10,
      "type": "lista",
      "logo": ""
   }, 
   "forza-italia":{
      "label": "Forza Italia",
      "short_label": "FI",
      "color": "#0E68A7",
      "political_pos": 11,
      "type": "lista",
      "logo": ""
   },
   "partito-democratico":{
      "label": "Partito Democratico",
      "short_label": "PD",
      "color": "#DE1121",
      "political_pos": 12,
      "type": "lista",
      "logo": ""
   },
   "autonomie-per-leuropa":{
   "label": "Autonomie Per L'Europa",
   "short_label": "",
   "color": "#0058A2",
   "political_pos": 13,
   "type": "lista",
   "logo": ""
   },
   "forza-nuova":{
      "label": "Forza Nuova",
      "short_label": "FN",
      "color": "#000",
      "political_pos": 14,
      "type": "lista",
      "logo": ""
   },
   "svp":{
      "label": "SVP",
      "short_label": "SVP",
      "color": "#000",
      "political_pos": 15,
      "type": "lista",
      "logo": ""
   },
   "europa-verde":{
      "label": "Europa Verde",
      "short_label": "Europa Verde",
      "color": "#54AE5D",
      "political_pos": 16,
      "type": "lista",
      "logo": ""
   },
   "movimento-5-stelle":{
      "label": "Movimento 5 Stelle",
      "short_label": "M5S",
      "color": "#eecc00",
      "political_pos": 8,
      "type": "lista",
      "logo": ""
   },
   "popolo-della-famiglia-alternativa-popolare":{
      "label": "Popolo Della Famiglia - Alternativa Popolare",
      "short_label": "",
      "color": "#013A6D",
      "political_pos": 17,
      "type": "lista",
      "logo": ""
   },
   "la-sinistra":{
      "label": "La Sinistra",
      "short_label": "La Sinistra",
      "color": "#C61A20",
      "political_pos": 18,
      "type": "lista",
      "logo": ""
   },
   "partito-comunista":{
      "label": "Partito Comunista",
      "short_label": "PC",
      "color": "#9c030d",
      "political_pos": 2,
      "type": "lista",
      "logo": ""
   },
   "lega-salvini-premier":{
      "label": "Lega Salvini Premier",
      "short_label": "Lega",
      "color": "#096224",
      "political_pos": 5,
      "type": "lista",
      "logo": ""
   },
   "fratelli-ditalia":{
      "label": "Fratelli d'Italia",
      "short_label": "FDI",
      "color": "#074A71",
      "political_pos": 7,
      "type": "lista",
      "logo": ""
   },
   "partito-pirata":{
      "label": "Partito Pirata",
      "short_label": "Partito Pirata",
      "color": "#000",
      "political_pos": 3,
      "type": "lista",
      "logo": ""
   },
   "partito-animalista":{
      "label": "Partito Animalista",
      "short_label": "Partito Animalista",
      "color": "#a7a099",
      "political_pos": 4,
      "type": "lista",
      "logo": ""
   },
   "popolari-per-litalia":{
      "label": "Popolari Per L'Italia",
      "short_label": "",
      "color": "#058DBD",
      "political_pos": 6,
      "type": "lista",
      "logo": ""
   },
   "ppa-movimento-politico-pensiero-azione":{
      "label": "Ppa Movimento Politico Pensiero Azione",
      "short_label": "PPA",
      "color": "#9FCFDD",
      "political_pos": 9,
      "type": "lista",
      "logo": ""
   }
}

export {Ep2019ListConfig}



// WEBPACK FOOTER //
// ./public/ep2019_listconfig.js